export const environment = {
  tag: 'production',
  production: true,
  url: 'https://www.hooksounds.com/', // With trailing slash
  frontUrl: 'https://www.hooksounds.com/',
  honeybadger: {
    browserKey: 'hbp_6FlqFAIb622zTnCwkg5TQMlMousN3p2wtv5n',
    serverKey: 'hbp_xu4Tc8l90a7d3WK24mzf40mU2A3eCk0pAwMx'
  },
  sentry: {
    browserDsn: 'https://d0032e53c16944aea255cba421c33492@o512250.ingest.sentry.io/5693147',
    browserSampleRate: 0.1,
    serverDsn: 'https://7254c2278c054387b1c8d96499dc562d@o512250.ingest.sentry.io/5650720',
    serverSampleRate: 0.1
  },
  gtag: 'UA-78898400-1',
  adWordsId: 'AW-1058848674',
  adWordsFreeConversion: 'ARwHCIynluoBEKL_8vgD',
  adWordsSongsConversion: 'kJCkCMPUkOQBEKL_8vgD',
  adWordsSubscriptionsConversion: 'JOCSCKasluoBEKL_8vgD',
  distFolder: '/home/hooksounds/public_html',

  experimentIds: {
    homeSearch: 'l6lmFPuzT_iLhH1uQElCxg',
    recommendedResults: '_ILlG9flQTC26KnBeUjg5w',
    CTA: 'TAHZ6xhxSOyQTLM_-JGbug',

    switchToSubscription: 'hkJSZyoNQ6qAPTHQc9sIsg',
    popupAddedToCart: 'qXs4RgQDQwGLruxcLo2oog',
    popupShoppingCart: 'bpg06PJGRNyYvWJ773Wj2g',

    recommendationsInEmptyCart: 'qgVAi5gKQf6kVbcDkVwt3Q',
    feedbackAddToCart: 'dzycioY_Rf-mQUuP-BH1Ug',
    strikePricesInCheckout: 'NUHDP8dhQOS6k9aVmrCUow'
  }
};
